import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useDownloadCardex = () => {
  const [loading, setLoading] = useState(true);

  const { enqueueSnackbar } = useSnackbar();

  const downloadCardex = ({
    zoneGuid,
    branchGuid,
    selectedBranch,
    selectedZone,
  }) => {
    axiosClient
      .get(
        `Inventory/StockCard/Report?GuidBranch=${branchGuid}&GuidZone=${zoneGuid}`,
        {
          responseType: 'blob',
        },
      )
      .then(res => {
        if (res.status === 200) {
          const type = res.headers['content-type'];
          const blob = new Blob([res.data], {
            type,
            encoding: 'UTF-8',
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `کاردکس (${selectedBranch} - ${selectedZone}).xlsx`;
          // `کاردکس ( ${selectedBranch} - ${selectedZone})` + `.xlsx`;
          link.click();
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [downloadCardex, loading];
};

export default useDownloadCardex;
